import type { RouteObject } from 'react-router-dom';
import { ROUTE_CONSENT } from '../../../constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { Page } from './consent.page';

export const routeConsent: RouteObject = {
  path: ROUTE_CONSENT,
  Component: Page,
  loader: setTitleFromLoader('Consent Document'),
};
